import React from 'react';
import I18n from 'i18n-js';
import { RCPill, RCPills } from '@reverbdotcom/commons/src/rc/RCPill';
import { reverb_personalization_TrendingSearch } from '../schemas/rql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';

interface IProps {
  onClick: Function;
  trendingSearches: reverb_personalization_TrendingSearch[];
}
export function SearchFormTrendingSearches(props: IProps) {
  const trendingSearches = props.trendingSearches || [];
  if (!trendingSearches?.length) return null;

  const isAllSameCategory = trendingSearches.every(ts => ts.categoryUuid === trendingSearches[0].categoryUuid);

  const renderTrendingSearchesHeader = () => {
    if (isAllSameCategory) {
      return I18n.t('discovery.siteSearch.trendingSearches.trendingInHeader', { productCategory: productCategory(trendingSearches[0].categoryUuid) });
    } else {
      return I18n.t('discovery.siteSearch.trendingSearches.generalTrendingHeader');
    }
  };

  const renderTrendingSearchPill = (trendingSearch) => {
    return (
      <span className='rc-pill__text'>
        { isAllSameCategory ?
          <b>{trendingSearch.query}</b>
          :
          <span>
            <SanitizedRender
              html={
                I18n.t('discovery.siteSearch.trendingSearches.trendingInPill',
                  { query: trendingSearch.query,
                    productCategory: productCategory(trendingSearch.categoryUuid),
                    tagOpen: '<b>',
                    tagClose: '</b>',
                  },
                )
              }
            />
          </span>
        }
      </span>
    );
  };

  const productCategory = (uuid) => {
    return I18n.t(`discovery.taxonomy.${uuid}`);
  };

  return (
    <div className="site-search__dropdown__section">
      <div className="site-search__dropdown__section__heading">
        {renderTrendingSearchesHeader()}
      </div>
      <div className='trending-searches__container'>
        <RCPills>
          {trendingSearches.map((ts, index) =>
            <RCPill
              key={ts.query}
              handleAction={() => props.onClick(ts, (index + 1))}
            >
              {renderTrendingSearchPill(ts)}
            </RCPill>,
          )}
        </RCPills>
      </div>
    </div>
  );
}
export default SearchFormTrendingSearches;
